// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate, {
  locale: 'es',
  dictionary :{
    es: {
      messages: {
        required: 'El campo es requerido',
        email: 'Debe ingresar un Email válido',
        is: 'Los correos no coinciden',
        min: (field, args) => {
          return `El campo debe tener un minimo de ${args[0]} caracteres`
        },
        max: (field, args) => {
          return `El campo debe tener un máximo de ${args[0]} caracteres`
        },
      }
    }
  }
});

Vue.use(Vuetify)

import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js